/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { SberBindCardMutationRequest, SberBindCardMutationResponse, SberBindCard400, SberBindCard401, SberBindCard500 } from "../entities/SberBindCard";

function getSberBindCardUrl() {
  const res = { method: 'POST', url: `/api/v1/payments/sber/bind-card` as const }
  return res
}

/**
 * @description Привязка банковской карты пассажира через Sber RegisterPreAuth.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * - Максимум 3 привязанных карты на пользователя
 * **Процесс:**
 * 1. Валидация входных данных (job_id — валидный UUID)
 * 2. Проверка лимита привязанных карт (максимум 3)
 * 3. Создание PaymentTransaction (type=AddCard, amount=100 коп, status=Created)
 * 4. При дубликате idempotency_key — возврат уже сохранённого URL
 * 5. Вызов Sber RegisterPreAuth (amount=100, features=[FORCE_TDS], clientID=userID)
 * 6. Обновление транзакции (status=WaitReverse, ext_order_id=orderId Сбера)
 * 7. Возврат `{formUrl}`
 * @summary Привязка банковской карты пассажира
 * {@link /api/v1/payments/sber/bind-card}
 */
export async function sberBindCard(data: SberBindCardMutationRequest, config: Partial<RequestConfig<SberBindCardMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SberBindCardMutationResponse, ResponseErrorConfig<SberBindCard400 | SberBindCard401 | SberBindCard500>, SberBindCardMutationRequest>({ method : "POST", url : getSberBindCardUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}